module.exports = {"Laboratory":"آزمایشگاه","":""}